<h4 class="title">External Unit Definition</h4>

<br>

<div class="card-box">
  <h4 class="title-f">Unit Details</h4>
  <div class="row" style="padding: 0px 0px 23px 10px;">
    <div class="col-md-6">
      <h5 class="form-lable">Internal/External:</h5>
      <input type="checkbox" style="width: 20px;"> (Select for Internal)
    </div>
    <div class="col-md-6">
        <h5 class="form-lable">Agency Name*:</h5>
        <input type="text" pInputText placeholder="">
      </div>
    <div class="col-md-6">
      <h5 class="form-lable">Unit Code*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-6">
        <h5 class="form-lable">Reporting To*:</h5>
        <input type="text" pInputText placeholder="">
      </div>
    <div class="col-md-6">
      <h5 class="form-lable">Unit Level*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-6">
        <h5 class="form-lable">Branch*:</h5>
        <input type="text" pInputText placeholder="">
      </div>
    <div class="col-md-6">
      <h5 class="form-lable">Bussiness Type*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-6">
        <h5 class="form-lable">Financier*:</h5>
        <input type="text" pInputText placeholder="">
      </div>
    
    <!-- <div class="col-md-12 mt-20">
          <button type="button" class="btn btn-primary">Add</button>
     </div> -->

  </div>
  <h4 class="title-f">Unit Capacity</h4>
  <div class="row" style="padding: 0px 0px 23px 10px;">
  
    <div class="col-md-6">
        <h5 class="form-lable">No. of Cases*:</h5>
        <input type="text" pInputText placeholder="">
      </div>
    <div class="col-md-6">
      <h5 class="form-lable">Total Amount Capacity*:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-6">
        <h5 class="form-lable">Assignment Duration*:</h5>
        <input type="text" pInputText placeholder="">
      </div>
    <div class="col-md-6">
      <h5 class="form-lable">Active*:</h5>
      <input type="checkbox" style="width: 20px;">
    </div>
    
    
    <!-- <div class="col-md-12 mt-20">
          <button type="button" class="btn btn-primary">Add</button>
     </div> -->

  </div>
  <h4 class="title-f">Signature</h4>
  <div class="row" style="padding: 0px 0px 23px 10px;">
  
    <div class="col-md-6">
        <h5 class="form-lable">Maker ID:</h5>
        <input type="text" pInputText placeholder="">
      </div>
    <div class="col-md-6">
      <h5 class="form-lable">Make Date:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    
    
    <!-- <div class="col-md-12 mt-20">
          <button type="button" class="btn btn-primary">Add</button>
     </div> -->

  </div>
</div>